import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/SmoothScroll";
import HeaderNav from "@/components/HeaderNav";
import FooterSection from "@/components/FooterSection";
import HomePage from "@/pages/HomePage";
import CompanyProfilePage from "@/pages/CompanyProfilePage";

// Scrolls to a hashed section on navigation, or to the top on plain route changes.
function ScrollManager() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            const id = hash.replace("#", "");
            let tries = 0;
            const tryScroll = () => {
                const el = document.getElementById(id);
                if (el) {
                    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
                    else el.scrollIntoView({ behavior: "smooth" });
                } else if (tries++ < 25) {
                    setTimeout(tryScroll, 50);
                }
            };
            setTimeout(tryScroll, 60);
        } else {
            if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
            else window.scrollTo(0, 0);
        }
    }, [pathname, hash]);
    return null;
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <SmoothScroll />
                <ScrollManager />
                <HeaderNav />
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/company-profile" element={<CompanyProfilePage />} />
                </Routes>
                <FooterSection />
                <Toaster position="top-center" richColors />
            </BrowserRouter>
        </div>
    );
}

export default App;
